const DAY = 864e5;

export const PRESETS = ["today", "7d", "30d", "custom"];

export const toDateInput = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

export function computeRange(preset, from, to) {
  const now = new Date();
  if (preset === "today") {
    const s = new Date(now);
    s.setHours(0, 0, 0, 0);
    return { start: s, end: now };
  }
  if (preset === "7d") return { start: new Date(now - 7 * DAY), end: now };
  if (preset === "30d") return { start: new Date(now - 30 * DAY), end: now };
  const s = new Date(`${from}T00:00`);
  const e = new Date(`${to}T00:00`);
  e.setDate(e.getDate() + 1);
  return { start: s, end: e };
}

const esc = (v) => {
  const s = v === null || v === undefined ? "" : String(v);
  return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
};

export function exportCsv(data, { t, lang, catName, itemName, range }) {
  const rows = [];
  const add = (...r) => rows.push(r.map(esc).join(","));
  add(t("an.title"), `${range.start.toISOString()} → ${range.end.toISOString()}`);
  add();
  add(t("an.metric"), t("an.current"), t("an.previous"), t("an.change"));
  Object.keys(data.summary).forEach((k) => add(t(`an.m.${k}`), data.summary[k], data.previous[k], data.changes[k] ?? ""));
  add();
  add(t("an.dish"), t("an.category"), t("an.views"), t("an.uniqueSessions"), t("an.avgView"), t("an.impressions"), t("an.openRate"), t("an.quickCloses"), t("an.change"));
  data.items.forEach((i) => add(itemName(i), catName(i.category_id), i.views, i.sessions, i.avg_view_s, i.impressions, i.open_rate ?? "", i.quick_closes, i.change_pct ?? ""));
  add();
  add(t("an.category"), t("an.clicksCol"), t("an.reach"), t("an.reachPct"), t("an.attentionCol"), t("an.views"));
  data.categories.forEach((c) => add(catName(c.id), c.clicks, c.reach_sessions, c.reach_pct, c.attention_s, c.item_views));
  add();
  add(t("an.searchTerm"), t("an.count"), t("an.noResults"));
  data.searches.forEach((s) => add(s.q, s.count, s.no_results));
  add();
  add(t("an.hour"), t("an.m.visits"));
  data.hourly.forEach((n, h) => add(h, n));
  add();
  add(t("an.funnel"), t("an.m.sessions"));
  ["visit", "browse", "dish", "continue"].forEach((k, i) => add(t(`an.f.${k}`), data.funnel[i]));
  add();
  add(t("an.date"), t("an.m.visits"), t("an.m.sessions"), t("an.m.dish_views"));
  data.timeline.forEach((b) => add(b.label, b.visits, b.sessions, b.dish_views));
  const blob = new Blob([`\ufeff${rows.join("\n")}`], { type: "text/csv;charset=utf-8" });
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = `wok-town-analytics-${toDateInput(range.start)}_${toDateInput(range.end)}-${lang}.csv`;
  a.click();
  URL.revokeObjectURL(a.href);
}
